import {
	loss_run_gantt_graff_init,
	loss_run_gantt_graff_layout,
	loss_run_gantt_graff_update_data,
} from './loss_run_gantt_graff.js';
import {initDatePicker, picker} from './datapicker.js';
import {drawInitialActivities, simpleActivity} from './activities.js';
import {draw_attachments} from './files.js';
import {draw_insured_tab, save_insured} from './insured.js';
import {draw_emails, draw_one_email} from './emails.js';
import {draw_address} from './address.js';
import {draw_images_slider} from './images_slider.js';
import {draw_ai_response_tab} from './ai_response.js';
import {draw_lead_log_tab} from './lead_log.js';
import {initializeReportTable} from './reportTable.js';

import {createImsSubmission, initControlNoCheck, initIMSButtons} from './services/export_to_ims.js';
import {createTFSubmission, initTFIDCheck} from './services/export_to_tf.js';

import { draw_lob_cards } from './cards.js';

import {
	draw_claims_table,
	draw_drivers_table,
	draw_loss_run_table,
	draw_terms_table,
	draw_vehicles_table,
} from './tables.js';
import {fetchLeadData} from './services/fetch.js';
import {draw_agent} from './agent.js';
import {convertMysqlDateTimeToJSDate, formatDateTime} from './utils/date_utils.js';
import {pushState, urlChangeEventTarget} from './feature/history.js';
import {escapeHtml} from './utils/escapeHtml.js';


let leadsListTable;


let disabledUpdates = new URL(window.location.href).searchParams.get('disabledUpdates') === '1';

urlChangeEventTarget.addEventListener('change', (event) => {
	// console.log(event.detail);
	const newURL = new URL(event.detail.newURL);
	const oldURL = new URL(event.detail.oldURL);
	const type = event.detail.type;
	if (type !== 'popstate') {
		// ignore if trigger not by back/forward button
		return;
	}

	if (newURL.pathname === oldURL.pathname) {
		// ignore hash change
		return;
	}
	let old_pathname = oldURL.pathname;
	switch (true) {
		case /^\/leads\/space\/\d+$/.test(old_pathname): {// Проверяет, что после /space/ идет число (ID)
			leadPopupAbortControler?.abort();
			break;
		}
		default:
			break;
	}

	let pathname = newURL.pathname;
	switch (true) {
		case pathname === '/leads/space':
			closeAllPopup();
			break;
		case /^\/leads\/space\/\d+$/.test(pathname): {// Проверяет, что после /space/ идет число (ID)
			closeAllPopup();
			let lead_id = get_lead_id_from_url();
			if (lead_id > 0) {
				getLeadData(lead_id, 'init');
				break;
			}
			break;
		}
		default:
			closeAllPopup();
			break;
	}

});


//// nav arrrow lead starts
function processLeadData(leadID) {
	if (leadID) {
		getLeadData(leadID, 'init');
	} else {
		console.log('No lead ID found');
	}
}

function getNextRow(callback){
	leadsListTable.page('next').draw(false);
	$('#leadsList').one('draw.dt', function(){
		let first_row = leadsListTable.rows({ page: 'current' }).data()[0];
		if(typeof first_row !== 'undefined'){
			callback(first_row['id']);
		}
	});
}
function getPrevRow(callback){
	let info = leadsListTable.page.info();
	if (info.page > 0) {
		leadsListTable.page('previous').draw(false);
		$('#leadsList').one('draw.dt', function () {
			let rows = leadsListTable.rows({page: 'current'}).data();
			let lastRow = rows[rows.length - 1]
			callback(lastRow['id']);
		});
	}
	else {
		$('.navigate_arrow_trigger.prev').hide();
		}
}
function updateNavigationArrowsVisibility() {
	$('.navigate_arrow_trigger').show();

	let currentLead = $('.lead_update_popup').attr('data-current-lead-id');
	let currentElement = $(`.card-wrap[data-lead-id="${currentLead}"]`);
	let hasPrev = currentElement.prev('.card-wrap').length > 0;
	let info = leadsListTable.page.info();

	if (info.page === 0 && !hasPrev) {
		$('.navigate_arrow_trigger.prev').hide();
	}else{
		$('.navigate_arrow_trigger.prev').show();
	}
}
//// nav arrrow lead ends

function updateSections() {
	$(".section").each(function() {
		let $section = $(this);
		if ($section.find(".card-wrap").length === 0) {
			$section.find('input.selectAll').hide();
			$section.find('input.selectAll').prop('checked', false);
			$section.addClass("section-collapsed");
		} else {
			$section.removeClass("section-collapsed");
			$section.find('input.selectAll').show();
		}
	});
}

function updateForLeadsCheckboxes() {
	let anyLeadChecked = $('.card-title input[type="checkbox"]:checked').length > 0;
	let countCheckedLeads = $('.card-title input[type="checkbox"]:checked').length;

	let last = countCheckedLeads > 1 ? 'leads' : 'lead';

	$('#active_leads_count').val(countCheckedLeads);
	$('.leads_count_title').html(countCheckedLeads + ' ' + last);
	// Remove existing btn if present
	$('.menu-left').find('.btn').remove();
	$('.menu-left').find('.btn-inv').remove();

}


function updateLeadsState(params, sectionName, place) {

	let leadsData = [];

	let isReadyToFile = false;
	{
		let propObj = {

			state: sectionName,
		};

		if (place === 'lead_update_update') {
			propObj.id = params.id;
		} else {
			propObj.id = $(this).attr('data-lead-id');
		}


		if (sectionName === 'ready_to_file') {
			isReadyToFile = true;
		}
		leadsData.push(propObj);
	}

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update-leads-state",
		data: {
			'leadsData': leadsData,
			'place': place,
		},
		cache: false,
		success: function (result) {
			if(result.code === 'SUCCESS'){

				updateSections();
				updateSectionCounts();
				 updateFilterCounts();
				if (place === 'lead_update_update') {
					getLeadData(params.id);

					// Show Submit to TF button if the state is 'ready_to_file'
					// if(isReadyToFile) {
					// 	$('.submit_api_transfed').removeClass('hidden');
					// } else {
					// 	$('.submit_api_transfed').addClass('hidden');
					// }

				} else {

				}
			}
		}
	});
}


function update_ims_quote_status() {
	let ims_status_id = $('#ims_status_id').val() || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update_ims_quote_status_id",
		data: {
			'ims_status_id': ims_status_id,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}


function updateAl_uw_id() {
	let al_uw_id = $('#al_uw_id').val() || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update_al_uw_id",
		data: {
			'al_uw_id': al_uw_id,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}

function updateUnderwriter() {
	let underwriter_id = $('#underwriter_id').val() || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update-underwriter",
		data: {
			'underwriter_id': underwriter_id,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}

function updateLineType(LineTypeId) {
	let line_type_id = LineTypeId || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update-line-type",
		data: {
			'line_type_id': line_type_id,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}



function updateSuggestedStatus(SuggestedStatusId) {
	let suggested_status_id = SuggestedStatusId || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update-suggested-status",
		data: {
			'suggested_status_id': suggested_status_id,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}

function updatePaperwork(paperwork) {
	let complete = paperwork || 0;
	let lead_id =  $('#lead_id').val();

	$.ajax({
		type: "POST",
		dataType: "json",
		url: "/leads/update-paperwork",
		data: {
			'complete': complete,
			'lead_id': lead_id,

		},
		cache: false,
		success: function (result) {
			if(result.status === 'SUCCESS'){


			}
		}
	});
}


function updateSectionCounts() {
	let $checkboxes = $('.card-wrap');

	$('.leads_content .section').each(function() {
		let qty = $(this).find('.card-wrap').length
		if(qty === 0){
			qty = '';
		}

		$(this).find('.cardQty').html(qty);
	});
}

function updateFilterCounts(startDate, endDate) {
	if (!$(`.filter-btn[data-status]`).length) return;

	if (!startDate) {
		let storedStartDate = localStorage.getItem('startDate');
		startDate = storedStartDate ? moment(storedStartDate) : moment().subtract(29, 'days');
		startDate = startDate.format('YYYY-MM-DD');
	}

	if (!endDate) {
		let storedEndDate = localStorage.getItem('endDate');
		endDate = storedEndDate ? moment(storedEndDate) : moment();
		endDate = endDate.format('YYYY-MM-DD');
	}

	$.ajax({
		url: '/Leads/get_leads_state_counts',
		type: 'POST',
		dataType: 'json',
		data: {
			'startDate': startDate,
			'endDate': endDate,
		},
		success: function (response) {
			if (response.status === 'SUCCESS') {
				response.lead_type_counts.forEach(type => {
					$(`.filter-btn[data-status='${type.filter_type}']`).find('.count').html(type.lead_count);
				});
			}
		},
	});
}
let previousUrl = '/leads/space';

/**
 *
 * @type {HTMLElement[]}
 */
let openPopupElements = [];

/**
 *
 * @param {HTMLElement} html_element
 */
function openPopup(html_element) {
	if (!(html_element instanceof HTMLElement)) {
		console.warn('can not open popup `html_element` is not HTMLElement');
		return;
	}
	if (openPopupElements.includes(html_element)) {
		console.warn('popup is already opened');
		return;
	}

	document.body.classList.add('noscroll');

	if (openPopupElements.length) {
		let prevPopup = openPopupElements[openPopupElements.length - 1];
		prevPopup.classList.remove('open');
		prevPopup.classList.add('open-in-background');
	}
	openPopupElements.push(html_element);
	html_element.classList.add('open');
}


function closeAllPopup() {
	for (const popup of openPopupElements) {
		popup.classList.remove('open');
		popup.classList.remove('open-in-background');
	}

	openPopupElements.length = 0;

	document.body.classList.remove('noscroll');
}

/**
 *
 * @param {HTMLElement} html_element
 */
function closePopup(html_element) {
	if (!(html_element instanceof HTMLElement)) {
		console.warn('can not open popup `html_element` is not HTMLElement');
		return;
	}
	if (!openPopupElements.includes(html_element)) {
		console.warn('popup is not opened');
		return;
	}

	let lastPopup = openPopupElements[openPopupElements.length - 1];
	if (lastPopup === html_element) {
		closeCurrentPopup();
		return;
	}
	openPopupElements.splice(openPopupElements.indexOf(html_element), 1);
	html_element.classList.remove('open-in-background');
}
function closeCurrentPopup() {

	let lastPopup = openPopupElements.pop();
	if (lastPopup) {
		lastPopup.classList.remove('open');
		if (openPopupElements.length) {
			let prevPopup = openPopupElements[openPopupElements.length - 1];
			prevPopup.classList.add('open');
			prevPopup.classList.remove('open-in-background');
		}
		if (!openPopupElements.length) {
			document.body.classList.remove('noscroll');
		}
	}
}

function get_lead_id_from_url(){
	const pathname = window.location.pathname;

	const regex = /^\/leads\/space\/(\d+)$/;
	const match = pathname.match(regex);

	if(match === null) {
		return null
	}
	const lead_id = +match[1];
	if (Number.isInteger(lead_id)) {
		return lead_id;
	}
	return null
}


function checkOpenLeadUpdatePopup() {
	const pathname = window.location.pathname;

	const lead_id = get_lead_id_from_url();

	if (lead_id > 0) {
		openPopup($('.lead_update_popup').get(0));
		$('.lead_update_popup').attr('data-current-lead-id', String(lead_id));
		getLeadData(lead_id, 'init');
	}
}

function drawInitialActivityEmail(emails) {
	const firstEmail = emails.reduce((min, current) => {
		return current.id < min.id ? current : min;
	});
	const emailHtml = draw_one_email(firstEmail, 0);
	// Append the email HTML to the email list
	$('.full-story-history').append(emailHtml);
}

/**
 *
 * @type {AbortController | undefined}
 */
let leadPopupAbortControler;
function getLeadData(lead_id, condition) {
	leadPopupAbortControler?.abort();
	leadPopupAbortControler = new AbortController();
	let {signal} = leadPopupAbortControler

	$('#message').html('');

	if($('.single_tab.active').attr('data-tab') === '#lead_log'){
		$('.clean_log_wrap').show();
	} else {
		$('.clean_log_wrap').hide();
	}

	if($('.single_tab.active').attr('data-tab') === '#lead_log'){
		$('.delete_all_lead_files_and_data_wrap').show();
	} else {
		$('.delete_all_lead_files_and_data_wrap').hide();
	}

	let promiseLeadData = fetchLeadData(lead_id, condition, {
		signal,
	});
	const hash = window.location.hash;
	previousUrl = window.location.pathname;
	let newUrl = '/leads/space/' + lead_id + hash;

	if (window.location.href !== new URL(newUrl, window.location.href).href){
		pushState(null, newUrl);
	}




	// open popup
	openPopup($('.lead_update_popup').get(0));


	// Clear existing popup

	$('.fails-select').val('').trigger('change');

	$(`.card-wrap[data-lead-id="${lead_id}"] .lead-dot span`).empty();
	$(`.card-wrap[data-lead-id="${lead_id}"] .lead-company_name`).empty();
	$('.lead_update_popup .popup-usdot span').empty();

	$('.lead_update_popup .story-date-created .value').empty();
	$('.lead_update_popup .story-date-updated .value').empty();
	$('.lead_update_popup .popup-title span').empty();
	$('.lead_update_popup .description').empty();
	$('.lead_update_popup #lead_id').val('');
	$('.lead_update_popup .lead_number_section').empty();
	$('.lead_update_popup #lead_details').val('');
	$('.lead_update_popup #lead_details').val('');
	$('.lead_update_popup #efficiency').val('');
	$('.lead_update_popup #tokens').val('');
	$('#lead_state_select').val('')
	$('.full-story-history').empty();
	$('#paperwork_section').hide();

	// Clear existing comments
	$('.lead_update_popup .duplicates_content').empty(); // Clear existing duplicates
	$('#duplicates .current_lead_wrapper').empty(); // Clear existing duplicates
	$('#duplicates .duplicates_wrapper').empty(); // Clear existing duplicates
	$('.lead_update_popup .files_wrap .file-wrap').remove(); // Clear existing loaded files
	$('#lead_log').empty(); // Clear existing lead log

	draw_drivers_table([]);
	draw_lob_cards([]);

	draw_vehicles_table([]);

	draw_loss_run_table([]);
	draw_terms_table([]);

	draw_claims_table([]);

	draw_agent({});

	draw_attachments({});

	draw_emails([]);

	draw_images_slider({});

	$('#underwriter_id').val('');

	$('.lead_update_popup .duplicates_content').append('<span class="no_duplicates ">No Duplicates</span>');

	draw_duplicates_tab(null);

	draw_ai_response_tab([])

	draw_insured_tab(null)

	draw_lead_log_tab('');

	fill_messenger_form(null);
	$('#messenger').removeClass('email_sent_success');

	loss_run_gantt_graff_update_data();

	draw_address({
		dot: '',
		company_name: '',
		line_1: '',
		line_2: '',
		city: '',
		state_code: '',
		zip: '',
		loading: true
	});



	promiseLeadData
		.then((result) => {

			if (result.code === 'SUCCESS') {
				$('.lead_update_popup').attr('data-current-lead-id', result.lead_data.id);





				let fail_type_id = result.lead_data.info.fail_type_id;
				let fail_option = $('.fails-select option').filter(function () {
					return $(this).val().trim() === fail_type_id; // Ensure trimming to avoid whitespace issues
				});
				if (fail_option.length) {
					$('.fails-select').val(fail_option.val()).trigger('change');
				} else {
					$('.fails-select').val('').trigger('change');
				}

				$(`.card-wrap[data-lead-id="${lead_id}"] .lead-dot span`).html(result.lead_data.info.dot);
				$(`.card-wrap[data-lead-id="${lead_id}"] .lead-company_name`).html(result.lead_data.info.company_name);

				$('.lead_update_popup .popup-usdot span').html(result.lead_data.info.dot);

				$('.lead_update_popup .story-date-created .value').html(formatDateTime(convertMysqlDateTimeToJSDate(result.lead_data.info.added)));
				$('.lead_update_popup .story-date-updated .value').html(formatDateTime(convertMysqlDateTimeToJSDate(result.lead_data.info.update_date)));
				$('.lead_update_popup .popup-title span').html(result.lead_data.info.company_name);
				$('.lead_update_popup .description').html(result.lead_data.info.description);
				$('.lead_update_popup').attr('data-current-lead-id', result.lead_data.info.id);
				$('.lead_update_popup #lead_id').val(result.lead_data.info.id);
				$('.lead_update_popup .lead_number_section').html(result.lead_data.info.lead_number);
				$('.lead_update_popup #lead_details').val('');
				$('.lead_update_popup #lead_details').val(result.lead_data.info.details);


				$('.lead_update_popup #tokens').val(result.lead_data.tokens);
				// $('.lead_update_popup .state.selection').attr('data-selected-section-name', result.lead_data.info_filter_type_identificator);
				let leadTypeTitle = result.lead_data.info.lead_filter_type_identificator;
				let option = $('#lead_state_select').find('option').filter(function () {
					return $(this).val() === leadTypeTitle;
				});
				if (option.length) {
					// Set the select's value
					$('#lead_state_select').val(option.val());
					// Trigger change if you have any "onchange" logic
				//	$('#lead_state_select').trigger('change');
					// Finally refresh the Selectric UI
					 $('#lead_state_select').selectric('refresh');
				}

				$('.full-story-history').empty();

				drawInitialActivityEmail(result.lead_data.emails);
				drawInitialActivities(result.lead_data.activities);

				// Clear existing comments
				$('.lead_update_popup .duplicates_content').empty(); // Clear existing duplicates
				$('#duplicates .current_lead_wrapper').empty(); // Clear existing duplicates
				$('#duplicates .duplicates_wrapper').empty(); // Clear existing duplicates
				$('.lead_update_popup .files_wrap .file-wrap').remove(); // Clear existing loaded files
				$('#lead_log').empty(); // Clear existing lead log

				if (result.lead_data) {
					draw_drivers_table(result.lead_data.drivers);

					draw_lob_cards(result.lead_data.lead_ims_quotes);

					draw_vehicles_table(result.lead_data.vehicles);

					draw_loss_run_table(result.lead_data.loss_run);
					draw_terms_table(result.lead_data.terms);

					draw_claims_table(result.lead_data.claims);

					draw_agent(result.lead_data);

					draw_attachments(result.lead_data.files);

					draw_emails(result.lead_data.emails);

					initControlNoCheck(result.lead_data.lead_ims_selected);

					initTFIDCheck(result.lead_data.lead_ims_selected);

					initIMSButtons(result.lead_data);

					//if (Array.isArray(result.lead_data.pngFiles) && (result.lead_data.pngFiles).length > 0) {
					draw_images_slider(result.lead_data.pngFiles);
					//}

					if ( result.lead_data.info.underwriter_id ) {
						$('#underwriter_id').val(result.lead_data.info.underwriter_id);
 					} else {
						$('#underwriter_id').val('');
					}
					$('#underwriter_id').selectric('refresh');

					if (
						result.lead_data.lead_ims_selected &&
						result.lead_data.lead_ims_selected.tf_id
					) {
						$('#transfed_id').val(result.lead_data.lead_ims_selected.tf_id);
						$('.transfed_id_wrap').hide();
					} else {
						$('#transfed_id').val('');
						$('.transfed_id_wrap').show();
					}

					if (
						result.lead_data.lead_ims_selected &&
						result.lead_data.lead_ims_selected.last_control_number ) {
						$('#ims_control_number').val(result.lead_data.lead_ims_selected.last_control_number);
						$('.ims_control_number_wrap').hide();
					} else {
						$('#ims_control_number').val('');
						$('.ims_control_number_wrap').show();

					}


					if ( result.lead_data.info.al_uw_id ) {
						$('#al_uw_id').val(result.lead_data.info.al_uw_id);
					} else {
						$('#al_uw_id').val('');
					}
					$('#al_uw_id').selectric('refresh');


					if ( result.lead_data.info.ims_quote_status_id ) {
						$('#ims_status_id').val(result.lead_data.info.ims_quote_status_id);
					} else {
						$('#ims_status_id').val('');
					}
					$('#ims_status_id').selectric('refresh');


					if ( result.lead_data.info.suggested_status_id ) {
						$('#suggested_status_id').val(result.lead_data.info.suggested_status_id);
					} else {
						$('#suggested_status_id').val('');
					}
					$('#suggested_status_id').selectric('refresh');


					if ( result.lead_data.info.line_type_id ) {
						$('#line_type_id').val(result.lead_data.info.line_type_id);
					} else {
						$('#line_type_id').val('');
					}
					$('#line_type_id').selectric('refresh');



					if ( result.lead_data.info.complete && result.lead_data.info.complete == '1' ) {
						$('#paperwork').prop('checked', true);
					} else {
						$('#paperwork').prop('checked', false);
					}
					$('#paperwork_section').show();


					if (Array.isArray(result.lead_data.duplicates) && (result.lead_data.duplicates).length > 0) {
						draw_duplicates_section(result.lead_data.duplicates);
					} else {
						$('.lead_update_popup .duplicates_content').append('<span class="no_duplicates ">No Duplicates</span>');
					}
					draw_duplicates_tab(result.lead_data);


					draw_ai_response_tab(result.lead_data.ai_response);

					draw_insured_tab(result.lead_data);

					draw_lead_log_tab(result.lead_data.lead_log);
					$('.clean_log').attr('data-path', result.lead_data.archiveFolder);
					$('.delete_all_lead_files_and_data').attr('data-path', result.lead_data.archiveFolder);

					if (result.lead_data.condition && result.lead_data.condition === 'init') {
						fill_messenger_form(result.lead_data);
						$('#messenger').removeClass('email_sent_success');
					}

					loss_run_gantt_graff_update_data({
						loss_run_report_array: result.lead_data.loss_run_reports,
						loss_run_array: result.lead_data.loss_run,
						period_array: result.lead_data.periods,
					});

				}

				//get garage address for this lead
				if (result.lead_data.address && Object.keys(result.lead_data.address).length > 0) {
					draw_address(result.lead_data );
				} else {
					draw_address({
						dot: '',
						company_name: '',
						line_1: '',
						line_2: '',
						city: '',
						state_code: '',
						zip: '',
						states: result.lead_data.states
					} );
				}



				let hashBeforeQuestionMark = hash.split('?')[0];

				if (typeof hashBeforeQuestionMark !== 'undefined' && hashBeforeQuestionMark !== '') {
					turnTableTab($(`.single_tab[data-tab='${hashBeforeQuestionMark}']`));

					let afterEmailId = hash.split('emailId=')[1];
					if (afterEmailId) {
						$('.email-item[data-email-id="' + afterEmailId + '"]').trigger('click');
					}
				}
				updateNavigationArrowsVisibility();

				//Insured from IMS

			}
		})
		.finally(()=>{
			$('body').removeAttr('data-loading_lead_update_popup')
		})
	;
	$('body').attr('data-loading_lead_update_popup', '');
}




function fill_messenger_form(data){

	if (!data?.agent) {
		$('#messenger .messenger_to_email_label input#to_email').val('');
		//$('#to_email').val('').trigger('change');
	} else {
		$('#messenger .messenger_to_email_label input#to_email').val('');
	}

	if(data?.info?.id){
		$('.messenger_content #subject').val('RE: BSRI Submission #' + data.info.id);
	} else {
		$('.messenger_content #subject').val('');
	}
	if(data?.agent){
		$('#to_email').val(data.agent['email']);
	} else {
		$('#to_email').val('');
	}
	if(data?.user_address && data.user_address.billing_email){
		$('.messenger_content #from_email').val(data.user_address.billing_email);
	} else {
		$('.messenger_content #from_email').val('');
	}
	if(data?.user_address && data.user_address.first_name && data.user_address.last_name){
		$('.messenger_content #from_name').val(data.user_address.first_name + ' ' + data.user_address.last_name);
	} else {
		$('.messenger_content #from_name').val('');
	}

	$('.messenger_content #message').val('');
}

function draw_duplicates_section(data, place){
	data.forEach(item => {
		// Skip rendering if item.dot is empty or null
		if (!item.dot) {
			return;
		}
		$('.lead_update_popup .duplicates_content').append(
			`<div class="duplicates_item" data-duplicates-lead-id="${item.id}">
				<div class="duplicates_item_header">
					<div class="duplicates_item_dot">DOT: <span class="number">${item.dot}</span></div>
					<div class="duplicates_item_date">${formatDateTime(convertMysqlDateTimeToJSDate(item.added))}</div>
				</div>
				<div class="duplicates_item_company_name">${item.company_name}</div>
				<div class="duplicates_item_footer">
					<div class="submission_id">Submission #<span class="number">${item.id}</span></div>
					<div class="duplicates_item_state">State: <span class="state">${item.duplicate_state_title}</span></div>
				</div>
			</div>`
		);
	});
}


function draw_duplicates_tab(data){

	$('#duplicates .current_lead_wrapper').empty();
	if (data) {
		$('#duplicates .current_lead_wrapper').append(
			`<div class="duplicates_item" data-duplicates-lead-id="${data.info.id}">
				<div class="duplicates_item_header">
					<div class="duplicates_item_dot">DOT: <span class="number">${data.info.dot}</span></div>
					<div class="duplicates_item_date">${formatDateTime(convertMysqlDateTimeToJSDate(data.info.added))}</div>
				</div>
				<div class="duplicates_item_company_name">${data.info.company_name}</div>
				<div class="duplicates_item_footer">
					<div class="submission_id">Submission #<span class="number">${data.info.id}</span></div>
					<div class="duplicates_item_state">State: <span class="state">${data.info.lead_type_title}</span></div>
				</div>
				<div class="counts">
					<div class="count_wrapper"><span class="label">Drivers:</span><div class="count">${data.drivers ? data.drivers.length : 0}</div></div>
					<div class="count_wrapper"><span class="label">Vehicles:</span><div class="count">${data.vehicles ? data.vehicles.length : 0}</div></div>
					<div class="count_wrapper"><span class="label">Loss Runs:</span><div class="count">${data.loss_run ? data.loss_run.length : 0}/3</div></div>
				</div>
				<div class="complition">
					<div class="complition_wrapper"><span class="label">Complition:</span><div class="count">100%</div></div>
				</div>
			</div>`,
		);
	}

	let qty_duplicates = 0;

	if (data && Array.isArray(data.duplicates) && (data.duplicates).length > 0) {
		data.duplicates.forEach(item => {
			++qty_duplicates;
			$('#duplicates .duplicates_wrapper').append(
				`<div class="duplicates_item" data-duplicates-lead-id="${item.id}">
				<div class="duplicates_item_header">
					<div class="duplicates_item_dot">DOT: <span class="number">${item.dot}</span></div>
					<div class="duplicates_item_date">${formatDateTime(convertMysqlDateTimeToJSDate(item.added))}</div>
				</div>
				<div class="duplicates_item_company_name">${item.company_name}</div>
				<div class="duplicates_item_footer">
					<div class="submission_id">Submission #<span class="number">${item.id}</span></div>
					<div class="duplicates_item_state">State: <span class="state">${item.duplicate_state_title}</span></div>
				</div>
				<div class="counts">
					<div class="count_wrapper"><span class="label">Drivers:</span><div class="count">${item.lead_drivers_count}</div></div>
					<div class="count_wrapper"><span class="label">Vehicles:</span><div class="count">${item.vehicles_count}</div></div>
					<div class="count_wrapper"><span class="label">Loss Runs:</span><div class="count">${item.loss_runs_count}/3</div></div>
				</div>
				<div class="complition">
					<div class="complition_wrapper"><span class="label">Complition:</span><div class="count">100%</div></div>
				</div>
			</div>`
			);
		});
	}

	$('.qty_duplicates').html('[' + qty_duplicates + ']');

}

function turnTableTab(self) {

	$('.tabs_wrap .single_tab').removeClass('active');
	$('.lead_update_popup').find('.tabs_wrap_content').removeClass('active');
	let tab = $(self).attr('data-tab');
	$(self).addClass('active');
	$(tab).addClass('active');

	if($(self).attr('data-tab') === '#lead_log'){
		$('.clean_log_wrap').show();
	} else {
		$('.clean_log_wrap').hide();
	}

	if($(self).attr('data-tab') === '#lead_log'){
		$('.delete_all_lead_files_and_data_wrap').show();
	} else {
		$('.delete_all_lead_files_and_data_wrap').hide();
	}

	if ($(self).attr('data-tab') === '#loss_runs') {
		loss_run_gantt_graff_layout();
	} else {
	}

}


function performGroupAction(action,selectedSection) {
	let selectedIds = $('.selectRow:checked').map((_, el) => $(el).val()).get();

	if (selectedIds.length === 0) {
		alert('Please select at least one row.');
		return;
	}
	console.log(action,selectedSection)


	$.ajax({
		url: "/leads/group-action",
		type: "POST",
		dataType: "json",
		data: {
			'action': action,
			'selectedSection': selectedSection,
			'ids': selectedIds
		},
		cache: false,
		success: function(result) {
			if (result.status === 'success') {
				leadsListTable.draw();
			 	updateFilterCounts();

				closeAllPopup()
			} else {
				alert('Failed to perform the action.');
			}
		},
		error: function() {
			alert('Error while performing the action.');
		}
	});

}


function requestReProcessType() {
	let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
	$('.re_process_data').addClass('loading').html('Please wait...');
	$.ajax({
		url: '/functions/checkAgent',
		type: 'POST',
		dataType: 'json',
		data: { lead_id: lead_id },
		cache: false,
		success: function (result) {
			if (result.code === 'SUCCESS') {
				console.log(result.messages); // Debugging output
				$('.re_process_type').removeClass('loading').html('[Done] Re-process Type');
			} else {
				console.error(result.messages);
				$('.re_process_type').removeClass('loading').html('[Error] Re-process Type');
			}
		},
		error: function () {
			$('.re_process_type').removeClass('loading').html('[Error] Re-process Type');
		},
	});
}




function requestReProcessData(target, className) {
	let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
	$('.' + className).addClass('loading');
	$('.' + className).html('Please wait...');
	$.ajax({
		url: '/Re_process_email',
		type: 'POST',
		dataType: 'json',

		data: {
			'lead_id': lead_id,
			'target': target,
		},
		cache: false,
		success: function (result) {
			if (result.code === 'SUCCESS') {


				// TODO update popup lead data
				$('.' + className).removeClass('loading');
				$('.' + className).html('Re-process Data');
			}
		},
		error: function () {
			$('.' + className).removeClass('loading');
			$('.' + className).html('[Error] Re-process Data');
		},
	});
}
// Updated check_control_number.js
function check_control_number(cs) {
	// If cs = 2, then we need to save insured radio's control_number.
	// If cs = 1, we are using the manual control_number field.

	let is_save_new_email_agency_names = 0;
	let ims_control_number = $('#ims_control_number').val();
	$('#orig_lead_id').val('');
	$('#merge_source_clicked').val(1);

	if (cs === 2) {
		ims_control_number = $('#insured .radio_control_number:checked').val();
		$('#merge_source_clicked').val(2);
		is_save_new_email_agency_names = +$('#is_save_new_email_agency_names_with_updateInsure').prop('checked') || 0;
	}

	// Make sure we wait for save_insured() to complete
	save_insured({is_save_new_email_agency_names})
		.then(() => {
			// Now proceed with checking if control_number has length
			if (ims_control_number && ims_control_number.length > 0) {
				let lead_id = $('#lead_id').val();
				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: '/leads/check-control-number',
					data: {
						control_number: ims_control_number,
						lead_id: lead_id,
					},
					cache: false,
					success: function (result) {
						$('.confirm_merge_ims_quote_popup .curr_submission').html(lead_id);

						if (result.status === 'SUCCESS') {
							$('.confirm_merge_ims_quote_popup .merge_submission_wrap').show();
							$('.confirm_merge_ims_quote_popup #merge_submission')
								.prop('checked', true)
								.trigger('change');
							$('.confirm_merge_ims_quote_popup .link_to_subm').attr(
								'href',
								'/leads/space/' + result.id
							);
							$('.confirm_merge_ims_quote_popup .orig_submission').html(result.id);
							$('#orig_lead_id').val(result.id);

						} else {
							$('.confirm_merge_ims_quote_popup .merge_submission_wrap').hide();
							$('.confirm_merge_ims_quote_popup #merge_submission')
								.prop('checked', false)
								.trigger('change');
							$('.confirm_merge_ims_quote_popup .init_email_to_ims').html('');
						}
						$('.confirm_merge_ims_quote_popup .selected_control_no').html(ims_control_number);

						openPopup($('.confirm_merge_ims_quote_popup').get(0));

						// Optionally reload page in success
						 // location.reload();
					},
					error: function () {
						alert('Not saved!');
						// Optionally reload if needed
						// location.reload();
					},
				});
			} else {
				// If there's no control number, maybe reload or do something else
				  location.reload();
			}
		})
		.catch(() => {
			// Handle any error from save_insured if needed
			// For example, show an alert
			alert('Could not save Insured data.');
		});
}



$(document).ready(function() {






	if ($('#leadsList').length > 0) {

		initDatePicker();
		$('.input-daterange').on('apply.daterangepicker', function(ev, picker) {
			// Получаем выбранные даты из `daterangepicker`
			const startDate = picker.startDate;
			const endDate = picker.endDate;



			if (startDate && endDate) {
				const formattedStartDate = startDate.format('YYYY-MM-DD');
				const formattedEndDate = endDate.format('YYYY-MM-DD');
				updateFilterCounts(formattedStartDate, formattedEndDate);
			} else {
				console.error("startDate or endDate is undefined in apply.daterangepicker");
			}
			// updateFilterCounts(startDate, endDate);
		});

		loss_run_gantt_graff_init();

		// Check if a status is saved in local storage
		let savedStatus = localStorage.getItem('leadStatus') || '1'; // Default to '1' (Inbox)

		// Set the active button based on the saved status
		$('.filter-btn').removeClass('active');
		$(`.filter-btn[data-status="${savedStatus}"]`).addClass('active');

		$('#changeStatusSelected').on('click', function () {
			if ($('#leadsList tbody input[type="checkbox"]:checked').length > 0) {
				openPopup($('.change_status_popup_block').get(0));

			} else {
				openPopup($('.warning_change_status_block').get(0));
			}
			openModal();

		});

		function openModal() {
			$('#submission-select').select2('destroy');

			$('#submission-select').find('option').removeAttr('selected').first().prop('selected', true);

			initializeSelect2();
		}
		$('.fails-select').on('select2:select', function (e) {
			e.preventDefault();
			e.stopPropagation();

			$.ajax({
				type: "POST",
				dataType: "json",
				url: "/leads/update-leads-fail-status",
				data: {
					'fail_type_id': $('.fails-select').val(),
					'lead_id': $('.lead_update_popup').attr('data-current-lead-id'),
				},
				cache: false,
				success: function (result) {
					if(result.status === 'SUCCESS'){

					}
				}
			});
		});

		let ajaxTimeout;

		$('#transfed_id').on('change', function (e) {
			// if ( result.lead_data.lead_ims_selected.tf_id ) {
			//
			// 	$('#transfed_id').val(result.lead_data.lead_ims_selected.tf_id);
			// 	$('.transfed_id_wrap').hide();
			// } else {
			// 	$('#transfed_id').val('');
			// 	$('.transfed_id_wrap').show();
			//
			// }
			//
			// if ( result.lead_data.lead_ims_selected.last_control_number ) {
			// 	$('#ims_control_number').val(result.lead_data.lead_ims_selected.last_control_number);
			// 	$('.ims_control_number_wrap').hide();
			// } else {
			// 	$('#ims_control_number').val('');
			// 	$('.ims_control_number_wrap').show();
			//
			// }
			console.log('transfed_id');
		});



		$('#lead_details').on('keyup', function (e) {
			e.preventDefault();
			e.stopPropagation();

			if (ajaxTimeout) {
				clearTimeout(ajaxTimeout);
			}

			ajaxTimeout = setTimeout(function () {
				$.ajax({
					type: "POST",
					dataType: "json",
					url: "/leads/update-leads-details",
					data: {
						'lead_details': $('#lead_details').val(),
						'lead_id': $('.lead_update_popup').attr('data-current-lead-id'),
					},
					cache: false,
					success: function (result) {
						if (result.status === 'SUCCESS') {
							// Действия при успешном ответе
							console.log('Update successful');
						}
					},
					error: function(xhr, status, error) {
						console.error('Error occurred:', error);
					}
				});
			}, 1000);
		});

		$('.clean_log').on('click', function () {

			let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
			let log_path = $(this).attr('data-path');
			let btnWrap = $(this).parents('.clean_log_wrap');
			if (confirm('Are you sure you want to delete this log content?')) {
				$('#lead_log').html('');
				$.ajax({
					url: "/leads/clean-log",
					type: "POST",
					dataType: "json",

					data: {
						'lead_id': lead_id,
						'log_path': log_path,
					},
					cache: false,
					success: function (result) {
						if (result.status === 'success') {
							$('#lead_log').html('');
						} else {
							btnWrap.append(result.message);
						}
					}
				});
			}

		});

		$('.delete_all_lead_files_and_data').on('click', function () {

			let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
			let log_path = $(this).attr('data-path');
			let btnWrap = $(this).parents('.delete_all_lead_files_and_data_wrap');
			if (confirm('Are you sure you want to delete this lead files and data?')) {
				$('#lead_log').html('');
				$.ajax({
					url: "/leads/delete-all-lead-files-and-data",
					type: "POST",
					dataType: "json",

					data: {
						'lead_id': lead_id,
						'file_path': log_path,
					},
					cache: false,
					success: function (result) {
						if (result.status === 'success') {
							console.log('deleted');
							window.location = '/leads/space';
						} else {
							btnWrap.append(result.message);
						}
					}
				});
			}

		});


		$('.delete_selected_wraper .delete').on('click', function () {
			performGroupAction('delete');
			closeAllPopup()
		});
		$('.delete_selected_wraper').on('click','.cancel, .popup_cancel_top_cross', function () {
			closeAllPopup()
		});

		$('#deleteSelected').on('click', function () {
			if ($('#leadsList tbody input[type="checkbox"]:checked').length > 0) {
				openPopup($('.delete_selected_block').get(0));
			} else {
				openPopup($('.warning_delete_selected_block').get(0));
			}
		});

		$('.warning_delete_selected_block, .warning_change_status_block').on('click', '.ok_btn, .cancel_btn, .popup_cancel_top_cross', function () {
			closePopup($('.warning_delete_selected_block').get(0));
			closePopup($('.warning_change_status_block').get(0));
		});






		$('.change_status_popup_wrapper .sub_content_label.lead_state_update').on('click', function () {
			$('.change_status_popup_wrapper .sub_content_label.lead_state_update').removeClass('active');
			$(this).toggleClass('active')
			let selectedSection = $(this).text();

			$('.change_status_popup_wrapper .state.selection.block').text(selectedSection)
			// let action = 'change_status'
			// console.log(action,selectedSection)
			// performGroupAction(action, selectedSection);
		});




		function initializeSelect2() {
			$('#submission-select').select2({
				templateResult: formatOption,
				templateSelection: formatOption,
				minimumResultsForSearch: Infinity,
				multiple: false,
				width: '100%',
			});
		}

		initializeSelect2();


		$('.change_status_popup_wrapper .ok_btn').on('click', function () {
			let selectedSection = $('#submission-select').val();
			let action = 'change_status'
			performGroupAction(action, selectedSection);

		})
		$('.change_status_popup_wrapper').on('click', '.popup_cancel_top_cross, .cancel',function () {
			closeAllPopup()
		})


		$('#selectAllCards').on('click', function (e) {
			e.stopPropagation();

			var isChecked = $(this).is(':checked');
			$('.selectRow').prop('checked', isChecked);
		});

		let windowHeight = $(window.top).height();
		let numberRows = Math.ceil((windowHeight - 318) / 34) - 2;
		if (numberRows < 10) {
			numberRows = 10;
		}
		if (numberRows > 100) {
			numberRows = 100;
		}

		leadsListTable = $('#leadsList').DataTable({
			'processing': true,
			'pageLength': numberRows,
			'aLengthMenu': [[numberRows, 10, 20, 50, 100], ['Auto', 10, 20, 50, 100]],
			'serverSide': true,
			'stateSave': true,
			'orderMulti': false,
			layout: {
				topStart: [
					function (settings) {
						console.log(settings);
						let $search = $.fn.dataTableExt.features['search'](settings, null);
						$search.prepend($('<a />', {
							'class': 'advanced-search-link',
							href: '/leads/advanced-search',
							text: 'Advanced Search',
						}));
						return $search;
					},
					'pageLength',
				],
				topEnd: [function (settings) {
					return $('.tableViewHeader').get(0);
				}],
				bottomStart: 'info',
				bottomEnd: 'paging',
			},
			'ajax': {
				'url': '/leads/get-lead-list',
				'type': 'POST',
				'data': function (d) {
					d.status = $('#status-filter-buttons .active').data('status') || ''; // Send the status as an additional parameter
					d.minDate = picker.startDate.format('YYYY-MM-DD');
					d.maxDate = picker.endDate.format('YYYY-MM-DD');
				},
			},
			'order': [[2, 'desc']],

			'columns': [
				{
					'data': 'id',
					'render': function (data, type, row) {
						return `<input type="checkbox" class="selectRow" value="${data}">`;
					},
					'searchable': false,
					'orderable': false,
				},
				{'data': 'id', 'searchable': true},

				{
					'data': 'added',   // The raw "2023-07-29 20:42:00"
					'render': function (value, type, row) {
						if (type === 'display') {
							return escapeHtml(row.added_m_d_Y_l_i_p_format);
						}
						else if (type === 'sort' || type === 'order') {
							// Sort by the raw datetime
							return value; // '2023-07-29 20:42:00'
						}
						// fallback for filter/type
						return value;
					},
					'className': 'nowrap'
				},
				{
					'name': 'line_type_title',
					'data': 'line_type_title',
					'searchable': true
				},
				{
					'data': 'effective_date',   // The raw "2023-07-29 20:42:00"
					'render': function (value, type, row) {
						if (type === 'display') {
							return escapeHtml(row.effective_date_m_d_Y_format);
						}
						else if (type === 'sort' || type === 'order') {
							// Sort by the raw datetime
							return value; // '2023-07-29 20:42:00'
						}
						// fallback for filter/type
						return value;
					},
					'className': 'nowrap'
				},

				{
					'name': 'business_type_text',
					'data': 'business_type_text',
					'searchable': true,
					'orderable': true,
				},
				{
					'name': 'paperwork',
					'data': 'paperwork',
					'searchable': true
				},

				{
					'name': 'suggested_status_title',
					'data': 'suggested_status_title',
					'searchable': true
				},
				{'data': 'dot', 'searchable': true},
				{'data': 'company_name', 'searchable': true},

				{'data': 'status', 'searchable': false},
				{'data': 'qty_drivers', 'searchable': false},
				{'data': 'qty_vehicles', 'searchable': false},
				{'data': 'qty_loss_runs', 'searchable': false},
				// {
				// 	'data': 'tokens',
				// 	'searchable': false,
				// 	'render': function (data, type, row) {
				// 		return escapeHtml(row.tokens_view);
				// 	},
				// },
				{
					'name': 'uw_name',
					'data': 'uw_name',
					'searchable': true,
					'orderable': true,
				}
			],
			'createdRow': function (row, data, dataIndex) {
				$(row).addClass('card-wrap');
				$(row).attr('data-lead-id', data.id);

			},
			initComplete: function () {
				updateNavigationArrowsVisibility();


			},
		});
		$(leadsListTable.tables().header()).find('tr.filter-row select').on('change', function () {
			let $select = $(this);
			let column_name = $select.attr('data-column');
			let val = $select.val();
			let search_regex_value = val ? '^' + $.fn.dataTable.util.escapeRegex(val) + '$' : '';

			leadsListTable.column(`${column_name}:name`)
				.search(search_regex_value, true, false)
				.draw();
		})

		leadsListTable.on('xhr.dt', function (e, settings, json, xhr) {
			if (xhr.status === 401) {
				DataTable.ext.errMode = 'throw';
				window.location = '/';
			}
		});





		$('#status-filter-buttons').on('click', '.filter-btn', function () {
			$('#status-filter-buttons .filter-btn').removeClass('active');
			$(this).addClass('active');
			let status = $(this).data('status');

			localStorage.setItem('leadStatus', status);

			if (status === 2) {
				leadsListTable.column('delete:name').visible(true); // Show the delete column
			} else {
				leadsListTable.column('delete:name').visible(false); // Hide the delete column
			}


			// Redraw the table with the new filter
			leadsListTable.ajax.reload();
		});

		function updateLeadsList () {
			leadsListTable.ajax.reload();
			let startDate = picker.startDate ? picker.startDate.format('YYYY-MM-DD') : '';
			let endDate = picker.endDate ? picker.endDate.format('YYYY-MM-DD') : '';
			updateFilterCounts(startDate,endDate);
		}

		function doUpdates() {
			updateLeadsList();
		}


		function setupUpdates() {
			if (disabledUpdates) return;
			//we can update data every minute
			// setTimeout(() => {
			// 	requestAnimationFrame(() => {
			// 		setupUpdates();
			//
			// 		doUpdates();
			// 	});
			// }, 60000);
		}

		setupUpdates();
	}


	$('#insured #updateInsuredMatch').on('click', function (e) {
		//we need to check if .radio_control_number checked
		//OR
		// #ims_control_number has value
		check_control_number(2);
		//
		//save_insured();
	});


	$('.submit_ims_control_number').on('click', function (e) {
		//open popup
		e.preventDefault();
		e.stopPropagation();


		let ims_control_number = $('#ims_control_number').val();
		if(!ims_control_number.length){
			alert('No Control No. Please input or select Control Number first!');
			return;
		}
		check_control_number();



	});


	$('.confirm_action_merge_ims_quote').on('click',   function (e) {
		e.preventDefault();
		e.stopPropagation();

		let $input = $(this);
		let checked = $input.prop('checked');

		let process = '0'
		if (checked) {
			process = '1';
		}
		let merge_source_clicked = $('#merge_source_clicked').val();

		let ims_control_number = $('#ims_control_number').val();
		if(merge_source_clicked == 2){
			ims_control_number = $('#insured .radio_control_number:checked').val()
		}
		let lead_id = $('#lead_id').val();
		let orig_lead_id = $('#orig_lead_id').val();

		let merge_submission = $('#merge_submission').prop('checked');
		let init_email_to_ims = $('#init_email_to_ims').prop('checked');
		$('.confirm_merge_ims_quote_wrapper').html('<p>Please wait...</p>');
		$.ajax({
			type: 'POST',
			dataType: 'json',
			url: '/leads/update-control-number',
			data: {
				'control_number': ims_control_number,
				'lead_id': lead_id,
				'merge_submission': merge_submission,
				'orig_lead_id': orig_lead_id,
				'init_email_to_ims': init_email_to_ims,
			},
			cache: false,
			success: function (result) {
				if (result.status === 'SUCCESS') {
					let stay = 1;
					let message = '<h5>Successfully saved!</h5>';
					if(result.email){
						message += '<p>Email successfully sent to IMS.</p>';
					}
					if(result.merge){
						stay = 0;
						message += '<p>Merge successfully completed. You will be redirected to the original submission.</p>';
					}
					message += '<p> &nbsp;</p>';
					$('.confirm_merge_ims_quote_wrapper').html(message)
					if(stay){
						setTimeout(function () {
							location.reload();
						}, 3000);


					} else {
						setTimeout(function () {
							location.href= '/leads/space/' + orig_lead_id;
						}, 3000);

					}
				//
				} else {
					alert('Error.');
				}
			},
			error: function () {
				alert('Error. Not saved!!');
			},
		});

	});


	//switch tabs inside of a single Lead
	$('.tabs_wrap').on('click', '.single_tab', function(e) {


		turnTableTab(this);

		let tab = $(this).attr('data-tab');
		let currentUrl = new URL(window.location.href);
		location.hash = tab;
	});
	//switch tabs inside of a single Lead
	$('.tabs_messenger_wrap').on('click', '.single_tab', function(e) {


		$('.tabs_messenger_wrap .single_tab').removeClass('active');
		$('.lead_update_popup').find('.tabs_messenger_wrap_content').removeClass('active');
		$(this).addClass('active');
		let tab = $(this).attr('data-tab');
		$(tab).addClass('active');


	});

//	checkOpenLeadUpdatePopup();

	// Initialize sortable areas
	// initializeSortable(".leads_content", ".leads_content");
	// initializeSortable(".section", ".section");



	// Sidebar toggle functionality
	$('.sidebar-switch').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const $sidebarWrap = $('.sidebar-wrap');
		$sidebarWrap.toggleClass('collapsed');
		$('.logo-wrap .logo').toggle();
	});

	// Toggle checkboxes and card title input visibility
	$('.selectAll').on('click', function(e) {
		let $checkboxes = $(`.card-wrap input[type="checkbox"][name="${this.id}"]`);
		let allChecked = $(e.target).is(':checked');

		// Show or hide card title inputs only related to the checkboxes with name "inbox"
		$checkboxes.each(function() {
			let $card = $(this).closest('.card-wrap');
			if (allChecked) {
				$card.find('.card-title input').removeClass('hide');
				$card.find('.card-title input').prop('checked', true);
			} else {
				$card.find('.card-title input').prop('checked', false);
				$card.find('.card-title input').addClass('hide');
			}
		});

		updateForLeadsCheckboxes();
	});


	// Catalog view selection functionality
	$(".catalogViewSelectionWrapper > div").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(".catalogViewSelectionWrapper div").removeClass("active");
		$(this).addClass("active");

		const isSquareActive = $('.catalogSquareWrapper').hasClass('active');
		$('.leads_content').toggleClass('squareIndicator', isSquareActive)
			.toggleClass('lineIndicator', !isSquareActive);
	});

	$(".state.selection").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(this).addClass('open');
	});





	$(".state.selection .sub_popup_cancel_top_cross").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		$('.state.selection').removeClass('open');
	});

	$(".sub_content_label").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(this).parents('.selection').find('.selection_content').html($(this).html());
		$(this).parents('.selection').attr('data-selected-section-name', $(this).attr('data-section-name'));
		$(this).parents('.selection').removeClass('open');
	});


	// Use event delegation to handle clicks on .card-wrap elements, including clones
	$(".leads_content").on("click", ".card-wrap", function (e) {
		if ($(e.target).is('input[type="checkbox"]')) {
			return;
		}

		let leadId = $(this).attr('data-lead-id');

		getLeadData(leadId, 'init');
	});


	$('#lead_state_select')
		.on('change', function(e) {
			e.preventDefault();
			e.stopPropagation();

			// Grab the <option> with the new value
			let sectionName = $(this).find(':selected').attr('data-section-name');

			let params = {
				id: $('#lead_id').val()
			};

			// Now call your existing function to do the update
			updateLeadsState(params, sectionName, 'lead_update_update');
		});

	$('#line_type_id')
		.on('change', function(e) {
			e.preventDefault();
			e.stopPropagation();
			// Now call your existing function to do the update
			updateLineType($(this).val());
		});

	$('#suggested_status_id')
		.on('change', function(e) {
			e.preventDefault();
			e.stopPropagation();
			// Now call your existing function to do the update
			updateSuggestedStatus($(this).val());
		});


	$('#paperwork')
		.on('change', function(e) {
			e.preventDefault();
			e.stopPropagation();
			const isChecked = $(this).is(':checked');
			// Now call your existing function to do the update
			updatePaperwork(isChecked);
		});


	$('.toolbar-btn').on('click', function() {

		$('.toolbar-btn').removeClass('active');
		$(this).addClass('active');


		let command = $(this).data('command');
		let value = $(this).data('value') || null;

		if (command === 'formatBlock' ) {
			document.execCommand('insertHTML', false, `<${value}>${window.getSelection().toString()}</${value}>`);
			console.log(`<${value}>${window.getSelection().toString()}</${value}>`)
		} else {
			document.execCommand(command, false, value);
		}
	});







	$(document).on('keydown', function (e) {
		if (e.key === "Escape" || e.key === "Esc") {
			closeCurrentPopup();
		}
	});
	$('body').on('click', '.cancel_popup, .popup_cancel_top_cross', function (e) {
		closeCurrentPopup();
	});
	$('.change_status_popup_block').on('click', function (e) {
		$(this).parents('.popup').find('.change_status_popup_wrapper .state_labels').hide();
	});
	$('.lead_update_popup .popup_cancel_top_cross').on('click', function (e) {
		leadPopupAbortControler?.abort();
		closeCurrentPopup();
		pushState(null, '/leads/space');
	});


	$('#underwriter_id').on('change', function(e) {
		e.preventDefault();
		e.stopPropagation();

		updateUnderwriter();
	});



	$('#al_uw_id').on('change', function(e) {
		e.preventDefault();
		e.stopPropagation();

		updateAl_uw_id();
	});

	$('#ims_status_id').on('change', function(e) {
		e.preventDefault();
		e.stopPropagation();

		update_ims_quote_status();
	});


	$('.leads_content').on('change', '.card-wrap input[type="checkbox"]', function(e) {
		e.preventDefault();
		e.stopPropagation();

		updateForLeadsCheckboxes();
	});

	$('.lead_update_popup .left_side_popup-header .popup-title').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$(this).find('span').hide();

		if($(this).find('textarea').length === 0){
			$(this).append(`<textarea id="re_name_title" name="re_name_title leads_auto_save">${$(this).find('span').html()}</textarea>`);

			let textarea = $('#re_name_title');
			let value = textarea.val();
			textarea.focus();
			textarea[0].setSelectionRange(value.length, value.length);
		}
	});

	$('.lead_update_popup .left_side_popup-header .popup-usdot').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$(this).find('span').hide();

		if($(this).find('textarea').length === 0){
			$(this).append(`<textarea id="re_name_usdot" name="re_name_usdot leads_auto_save">${$(this).find('span').html()}</textarea>`);

			let textarea = $('#re_name_usdot');
			let value = textarea.val();
			textarea.focus();
			textarea[0].setSelectionRange(value.length, value.length);
		}
	});

	// auto_save
	$(".leads_auto_save").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

	});

	$("#create_lead").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		openPopup($('.lead_create_popup').get(0));
	});

	$('.submit_api_transfed').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		createTFSubmission();

	});

	$('.submit_api_ims').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		let lead_id = $('.lead_update_popup').attr('data-current-lead-id');
		createImsSubmission(lead_id);
	});


	$('.re_process_type').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		openPopup($('.confirm_re_process_type_popup').get(0));

	});

	$('.confirm_re_process_type_popup').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		closePopup($('.confirm_re_process_type_popup').get(0));

		requestReProcessType();

	});


	$('.re_process_data').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		openPopup($('.confirm_re_process_data_popup').get(0));
	});


	$('.confirm_action_re_process_data').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		closePopup($('.confirm_re_process_data_popup').get(0));
		requestReProcessData(1, 're_process_data');
	});


	$('#process_data_btn').on('click', function(e) {
		e.preventDefault();

		let leadId = $('.lead_update_popup').data('current-lead-id');
		let selectedTargets = [];

		// Collect from checkboxes
		$('.target_checkbox:checked').each(function() {
			let targetsStr = $(this).attr('data-target'); // e.g. "12,55"
			if (targetsStr) {
				let arr = targetsStr.split(',');
				arr.forEach(function(t) {
					let num = parseInt(t.trim());
					if (!isNaN(num)) {
						selectedTargets.push(num);
					}
				});
			}
		});

		// Send to your Re_process_email or any endpoint
		$.ajax({
			url: '/Re_process_email',
			type: 'POST',
			dataType: 'json',
			data: {
				lead_id: leadId,
				// 'target': ??? if you want a single, but here we do partial
				'targets': JSON.stringify(selectedTargets)
			},
			success: function(resp) {
				console.log('Process Data response:', resp);
			}
		});
	});




	$('.re_process_data_with_email').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		openPopup($('.confirm_re_process_data_with_email_popup').get(0));
	});


	$('.confirm_action_re_process_with_email').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		closePopup($('.confirm_re_process_data_with_email_popup').get(0));
		requestReProcessData(11, 're_process_data_with_email');
	});







	$('.checking_report').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();


		let lead_id = $('#lead_id').val();
		let underwriter_id = $('#underwriter_id').val();
		if (underwriter_id > 0)  {

			$('#messenger').css('min-height', '500px');
			$('#message').css('min-height', '500px');
			$('#messenger .toggle_open_in_full').attr('data-open', '');


			$('.checking_report').addClass('loading');
			$('.checking_report').text('Please wait...');


			// getLeadData(leadId, 'init');

			fetchLeadData(lead_id, 'init')
				.then((result) => {
					let lead_state_select = $('#lead_state_select').val();
					let business_types_list = +$('#business_types_list').val();
					// switch (lead_state_select) {
					// 	case 'decline': {
					// 		switch (business_types_list) {
					// 			case 3: // Decline - Too early
					// 				return get_decline_too_early_response_message_text(result);
					// 			case 4: // Decline - Dublicate
					// 				return get_decline_dublicate_response_message_text(result);
					// 			default:
					// 				return get_decline_dublicate_response_message_text(result);
					// 		}
					// 	}
					// 	default:
					// 		return get_missing_info_response_message_text(result);
					// }
				})
				.then((email) => {
					// Updated to match the new return structure:
					$('#subject').val(email.subject);
					$('#message').html(email.body);

					$('.checking_report').removeClass('loading');
					$('.checking_report').html('Auto Response');

					$('[data-tab="#comments"]').click();
				})
				.catch((reason) => {
					console.error(reason);
					$('.checking_report').removeClass('loading');
					$('.checking_report').html('Auto Response [error]');
				});
		}  else {
			alert('Please Select Underwriter first! Thanks.');
			return;
		}
	});



	$("#popup_create_lead").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		let lead_id = $('#lead_id').val()
		let form_data = new FormData();
		let propObj = {
			state: $('.lead_create_popup .state.selection').attr('data-selected-section-name'),
			title: $('.lead_create_popup .popup-title span').html(),
			description: $('.lead_create_popup .description').html(),
		};


		for ( let key in propObj ) {
			form_data.append(key, propObj[key]);
		}

		$.ajax({
			url: "/leads/create-lead",
			type: "POST",
			dataType: "json",
			contentType: false,
			processData: false,
			data: form_data,
			cache: false,
			success: function (result) {
				if(result.code === 'SUCCESS'){
					$(`.leads_content .section[data-section-name="${result.lead.lead_filter_type_identificator}"]`).append(
						`<div class="card-wrap" data-name="${result.lead.lead_filter_type_identificator}" data-lead-id="${result.lead.id}">
							<div class="card-title">Lead #${result.lead.id} <input type="checkbox" name="${result.lead.lead_filter_type_identificator}" data-full-name="${result.lead.lead_type_title}" class="lead_checkbox"></div>
							<p>4 Deals</p>
						</div>`
					);
					updateSections();
					updateSectionCounts();

					$('.lead_create_popup .popup-title-content').val('');
					$('.lead_create_popup .description').html('');

					closePopup($('.lead_create_popup').get(0));
				}
			}
		});
	});

	$('.lead_update_popup.open').on('click', function(e) {
		if ($(e.target).parents('.popup_wrap').length === 0 && !$(e.target).hasClass('popup_wrap')) {
			leadPopupAbortControler?.abort();
			closeCurrentPopup();
			pushState(null, '/leads/space');
		}
	});

	$('.messenger_clear').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('#messenger')[0].reset();
	});

	$('.ask_bot_clear').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		$('#ask_bot')[0].reset();
	});

	$('.messenger_send').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let form_data = new FormData($('#messenger')[0]);
		const lead_id = $('.lead_update_popup').attr('data-current-lead-id');

		// Get the HTML message from the div with id="message"
		let email_message = $('#message').html() || '';
		form_data.append('message', email_message);
		form_data.append('lead_id', lead_id);

		$.ajax({
			url: "/leads/send-email",
			type: "POST",
			dataType: "json",
			contentType: false,
			processData: false,
			data: form_data,
			cache: false,
			success: function(result) {
				if (result.code === 'SUCCESS') {
					$('<div class="confirmation-message">Email sent successfully!</div>')
						.css({
							'position': 'absolute',
							'color': 'green',
							'border': '1px solid green',
							'padding': '0px 10px',
							'margin-top': '-20px',
							'bottom': '50px',
							'background-color': '#e6ffe6',
							'border-radius': '4px',
						})
						.prependTo('.messenger_buttons')
						.fadeOut(12500);

					// Reset form inputs
					$('#messenger')[0].reset();

					// Clear the HTML message div
					$('#message').html('');


					let promiseLeadData = fetchLeadData(lead_id);


					draw_attachments({});

					draw_emails([]);

					promiseLeadData
						.then((result) => {
							draw_attachments(result.lead_data.files);

							draw_emails(result.lead_data.emails);


							$('.full-story-history').empty();

							drawInitialActivityEmail(result.lead_data.emails);
							drawInitialActivities(result.lead_data.activities);

						})
						.finally(() => {
							$('body').removeAttr('data-loading_lead_update_popup_for_email');

						});

					$('#messenger').addClass('email_sent_success');



				} else {
					$('#messenger').addClass('email_sent_error');
					$('body').removeAttr('data-loading_lead_update_popup_for_email')
				}
			},
			error: function() {
				$('#messenger').addClass('email_sent_error');
				$('body').removeAttr('data-loading_lead_update_popup_for_email')
			}
		});

		$('body').attr('data-loading_lead_update_popup_for_email', '');
	});

	$('#messenger .toggle_open_in_full').on('click', function (e) {
		if ($('#messenger .toggle_open_in_full').is('[data-open]')) {
			$('#messenger').css('min-height', '');
			$('#message').css('min-height', '');
			$('#messenger .toggle_open_in_full').removeAttr('data-open');
		} else {
			$('#messenger').css('min-height', '500px');
			$('#message').css('min-height', '500px');
			$('#messenger .toggle_open_in_full').attr('data-open', '');
		}
	});

	$('.ask_bot_send').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let user_name = $('.user-info__user-name').text()
		let type_id = 6
		let form_data = new FormData($('#ask_bot')[0]);
		let activity = {
			'added': new Date(),
			'activity_message': form_data.get('bot_message'), // Get the bot message
			'type_id': 6,
			'user_name': user_name,
		};
		let request = simpleActivity(activity);
		$('.full-story-history').append(request);
		form_data.append('type_id', type_id);
		form_data.append('lead_id', $('.lead_update_popup').attr('data-current-lead-id'));

		$('#ask_bot').addClass('ask_bot_message');
		$('#ask_bot .messenger_content, #ask_bot .messenger_buttons').hide()

		$.ajax({
			url: "/leads/ask_bot",
			type: "POST",
			dataType: "json",
			contentType: false,
			processData: false,
			data: form_data,
			cache: false,
			success: function(result) {
				if (result.code === 'SUCCESS') {
					// $('<div class="confirmation-message">Email sent successfully!</div>')
					// 	.css({
					// 		'position': 'absolute',
					// 		'color': 'green',
					// 		'border': '1px solid green',
					// 		'padding': '0px 10px',
					// 		'margin-top': '-20px',
					// 		'bottom': '50px',
					// 		'background-color': '#e6ffe6',
					// 		'border-radius': '4px',
					// 	})
					// 	.prependTo('.messenger_buttons')
					// 	.fadeOut(1500);

					// $('#messenger')[0].reset();

					let response = simpleActivity(result.response);
					$('.full-story-history').append(response);


					getLeadData($('#lead_id').val());
				}
			},
			error: function(xhr, status, error) {
				console.error("AJAX error:", status, error);
			},
			complete: function() {
				$('#ask_bot')[0].reset();
				$('#ask_bot').removeClass('ask_bot_message');
				$('#ask_bot .messenger_content, #ask_bot .messenger_buttons').show();
			}
		});
	});

	 updateFilterCounts();

	$('.navigate_arrow_trigger').on('click', function(e) {
		let info = leadsListTable.page.info();
		if (info.page < 0) {
			$('.navigate_arrow_trigger.prev').hide();
		}
		e.preventDefault();
		e.stopPropagation();

		let action = $(this).attr('data-action');

		let currentLead = $('.lead_update_popup').attr('data-current-lead-id');
		let currentElement = $(`.card-wrap[data-lead-id="${currentLead}"]`);
		let neededLeadID = '';

		if(action === 'prev'){
			neededLeadID = currentElement.prev('.card-wrap').attr('data-lead-id');
			if(neededLeadID === null || typeof neededLeadID === 'undefined') {
				getPrevRow(function (lastRow){
					neededLeadID = lastRow;
					processLeadData(neededLeadID);
				})
			}
			else{
				getLeadData(neededLeadID, 'init');
			}

		} else {
			neededLeadID = currentElement.next('.card-wrap').attr('data-lead-id');
			if(neededLeadID === null || typeof neededLeadID === 'undefined') {
				getNextRow(function (firstRowId){
					neededLeadID = firstRowId;
					processLeadData(neededLeadID);
				});
			}else{
				getLeadData(neededLeadID, 'init');
			}
		}
	});


	let lastChecked = null;

	$('#leadsList').on('click', '.card-wrap .selectRow', function (e) {
		// Check if shift key is pressed and lastChecked exists
		if (e.shiftKey && lastChecked) {
			// Get all checkboxes
			let checkboxes = $('.card-wrap .selectRow').toArray();
			let start = checkboxes.indexOf(lastChecked);
			let end = checkboxes.indexOf(this);

			// Ensure valid indices before slicing
			if (start !== -1 && end !== -1) {
				$(checkboxes.slice(Math.min(start, end), Math.max(start, end) + 1))
					.each(function () {
						// Set the checked property based on lastChecked
						$(this).prop('checked', $(lastChecked).prop('checked'));
					});
			}
		}
		// Update lastChecked to the current checkbox
		lastChecked = this;
	});

	function formatOption(option) {
		if (!option.id) {
			return option.text;
		}
		var img = $(option.element).data('image');
		var text = option.text;
		var customClass = $(option.element).attr('class');
		var sectionName = $(option.element).data('section-name');
		if (img) {
			var $option = $('<span class="' + customClass + '" data-section-name="' + sectionName + '">' +
				'<img src="' + img + '" class="img-flag" style="width:20px; height:15px; margin-right:10px;" /> ' + text +
				'</span>');
			return $option;
		}
		return option.text;
	}

	$('.selectric').selectric();

	$('#lead_state_select________').select2({
		templateResult: formatOption,
		templateSelection: formatOption,
		minimumResultsForSearch: Infinity,
		multiple: false,
		width: '100%',
	});
	$('.fails-select').select2({
		multiple: false,
		width: '100%',
	});


	$('.email_success_close').on("click", function (e) {
		$('#messenger').removeClass('email_sent_success');
		$('#messenger').css('min-height', '');
		$('#message').css('min-height', '');
		$('#messenger .toggle_open_in_full').removeAttr('data-open');
	});

	$(document).on("click", ".duplicates_item", function (e) {
		e.preventDefault();
		e.stopPropagation();

		getLeadData($(this).attr('data-duplicates-lead-id'), 'init');
	});


	window.getLeadData = getLeadData;

	$('#comments').on('click', '.email-item', function () {
		turnTableTab($('.single_tab[data-tab="#emails"]'));
		let updatedUrl = window.location.href.replace(/(\?.+)$/, '#emails$1');
		if (window.location.href.includes('#')) {
			updatedUrl =  window.location.href.replace(/#\w+/, '#emails');
		}
		pushState(null, updatedUrl);
	});

	initializeReportTable();

	checkOpenLeadUpdatePopup();

	$("#lead_log").on('click', '.clean_log_link', function (e) {
		e.preventDefault(); // Prevent default link behavior

		const $this = $(this); // Store the clicked link
		const logFile = $this.data('file'); // Get the log file from a data attribute
		const originalText = $this.text(); // Store the original text
		const tooltipMessage = 'Processing...';

		// Prevent double-clicks
		if ($this.data('processing')) {
			return;
		}

		// Set the link to processing state
		$this.data('processing', true);
		$this.text(tooltipMessage); // Show processing message

		// Clear any existing tooltip
		//$this.attr('title', '').tooltip('dispose');

		// AJAX request
		$.ajax({
			url: '/leads/clean_log_link', // Adjust the URL to match your endpoint
			type: 'POST',
			dataType: 'json',
			data: {
				file: logFile
			},
			success: function (response) {
				let message;
				if (response.code === 'SUCCESS') {
					message = 'Log file cleaned successfully.';
					$this.addClass('text-success'); // Optional: Add a success style
				} else {
					message = response.message || 'Failed to clean the log file.';
					$this.addClass('text-danger'); // Optional: Add an error style
				}

				// Show tooltip with status
				//$this.attr('title', message).tooltip('show');

				// Reset the link text and processing state
				setTimeout(() => {
					$this.text(originalText);
					$this.data('processing', false);
				}, 3000); // Reset after 3 seconds
			},
			error: function () {
				const errorMessage = 'Error while processing the request.';
			//	$this.attr('title', errorMessage).tooltip('show');
				$this.addClass('text-danger');

				// Reset the link text and processing state
				setTimeout(() => {
					$this.text(originalText);
					$this.data('processing', false);
				}, 3000); // Reset after 3 seconds
			}
		});
	});


});
